"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.function.name");

var _QuickItem = _interopRequireDefault(require("./QuickItem"));

var _QuickLink = _interopRequireDefault(require("./QuickLink"));

var _BackTop = _interopRequireDefault(require("./BackTop"));

var _Mobile = _interopRequireDefault(require("./Mobile"));

var _Chat = _interopRequireDefault(require("./Chat"));

var _QrCode = _interopRequireDefault(require("./QrCode"));

var _DianShang = _interopRequireDefault(require("./DianShang"));

_QuickLink.default.BackTop = _BackTop.default;
_QuickLink.default.Chat = _Chat.default;
_QuickLink.default.Mobile = _Mobile.default;
_QuickLink.default.QrCode = _QrCode.default;
_QuickLink.default.QuickLinkItem = _QuickItem.default;
_QuickLink.default.DianShang = _DianShang.default;

_QuickLink.default.install = function install(Vue) {
  Vue.component(_QuickLink.default.name, _QuickLink.default);
  Vue.component(_BackTop.default.name, _BackTop.default);
  Vue.component(_Chat.default.name, _Chat.default);
  Vue.component(_Mobile.default.name, _Mobile.default);
  Vue.component(_QrCode.default.name, _QrCode.default);
  Vue.component(_DianShang.default.name, _DianShang.default);
  Vue.component(_QuickItem.default.name, _QuickItem.default);
};

var _default = _QuickLink.default;
exports.default = _default;